/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import System from './System';
function FederatedApp(_ref) {
  let {
    appData,
    fallback,
    appProps
  } = _ref;
  const [system, setSystem] = React.useState({});
  const {
    url,
    scope,
    module,
    remoteEntryFileName
  } = appData;
  useEffect(() => {
    setSystem({
      url,
      scope,
      module,
      remoteEntryFileName
    });
  }, []);
  return /*#__PURE__*/React.createElement(System, {
    system: system,
    appProps: appProps,
    fallback: fallback
  });
}
export { FederatedApp };